import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { DashboardContainer as Tiles } from '@smapiot/components';
import { usePiletApi } from 'piral-core';
import { DashboardContainerProps } from 'piral-dashboard';
import { useCurrentUser } from '@piral/portal-utils';

import { routes } from '../routes';

export const DashboardContainer: React.FC<DashboardContainerProps> = ({ children }) => {
  const api = usePiletApi();
  const [, user] = useCurrentUser(api);
  const history = useHistory();

  if (user instanceof Error) {
    history.push(routes.noauth);
    return null;
  }

  return (
    <div className="container dashboard-container">
      <Tiles>{children}</Tiles>
    </div>
  );
};
